import { useContext } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

import { AuthContext } from "src/contexts/auth.context";

import useTranslate from "src/hooks/use-translate";

import "./account.style.scss";

const PERSONAL_LIST = [
	{ label: "my profile", href: "/account" },
	{ label: "settings", href: "/account/settings" },
];

const COMPANY_LIST = [
	{ label: "information", href: "/account/company/information" },
	{ label: "people", href: "/account/company/people" },
	{ label: "plans", href: "/account/company/plans" },
];

const Account = () => {
	const { logout } = useContext(AuthContext);
	const location = useLocation();
	const t = useTranslate("Account");

	const handleLogOut = () => {
		logout();
	};

	return (
		<div className="account-container unselectable">
			<div className="left-panel">
				<h1 className="with-line">{t("account")}</h1>
				<div className="list-container">
					<p className="size500 w500 with-line">{t("personal")}</p>
					<div className="buttons-container">
						{PERSONAL_LIST.map(({ label, href }) => {
							const isSelected = href === location.pathname;
							return (
								<Link key={label} className={`button ${isSelected && "selected"}`} to={href}>
									{t(label)}
								</Link>
							);
						})}
						<button onClick={handleLogOut} className="button log-out">
							{t("log out")}
						</button>
					</div>
				</div>
				<div className="list-container">
					<p className="size500 w500 with-line">{t("company")}</p>
					<div className="buttons-container">
						{COMPANY_LIST.map(({ label, href }) => {
							const isSelected = href === location.pathname;
							return (
								<Link key={label} className={`button ${isSelected && "selected"}`} to={href}>
									{t(label)}
								</Link>
							);
						})}
					</div>
				</div>
			</div>
			<div className="right-panel">
				<Outlet />
			</div>
		</div>
	);
};

export default Account;
